import type { ErrorInfo } from 'react'

/**
 * Simple error reporting — logs to console
 */
export function reportError(report: { error: Error; errorInfo?: ErrorInfo }) {
  console.error('[Error]', report.error.message, report.errorInfo?.componentStack)
}

export function createErrorHandler() {
  return (error: Error, errorInfo: ErrorInfo) => {
    reportError({ error, errorInfo })
  }
}
